export default __webpack_public_path__ + "static/media/Logo.f6471dc9.png";